import React from 'react'
import { component_tool } from '@/tool'
import { WizTableForm } from '../../../../common'
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
let { WizDataTable, WizIcon, WizButton, WizDivider } = component_tool

export default (self, employees, other) => {
    return [
        {
            title: 'id',
            name: 'id',
            formItem: {
                type: 'hidden'
            }
        },
        {
            title: 'personId',
            name: 'personId',
            formItem: {
                type: 'hidden'
            }
        },
        {
            title: 'roleId',
            name: 'roleId',
            formItem: {
                type: 'hidden'
            }
        },
        {
            title: 'delFlag',
            name: 'delFlag',
            formItem: {
                type: 'hidden'
            }
        },

        {
            title: "所属组织",
            name: "organizationIdList",
            searchItem: {
              ...organizationConfig,
              diy: WizTableForm,
            }
          },

        {
            title: '用户属性',
            name: 'userType',
            searchItem: {
                type: 'select',
               //initialValue: 1
            },
            dict: [
                { code: 0, codeName: "培训平台用户" },
                { code: 5, codeName: "服务商用户" },
                { code: 4, codeName: "经销商用户" },
                { code: 3, codeName: "OEM部门" }
              ],
            formItem: {
                type: 'select',
                rules: [{
                    required: true,
                    message: '请选择'
                }]
            }
        },

        {
            title: '账号',
            name: 'userName',
            searchItem: {},
            tableItem: {},
            formItem: {
                rules: [{
                    required: true,
                    message: '请输入账号'
                }],
            }
        },
        {
            title: '姓名',
            name: 'fullName',
            tableItem: {},
            searchItem: {},
            formItem: {
                rules: [{
                    required: true,
                    message: '请输入姓名'
                }],
            }
        },

        {
            title: '手机号',
            name: 'mobile',
            tableItem: {},
            formItem: {}
        },
        {
            title: '证件号码',
            name: 'idCard',
            tableItem: {},
            formItem: {}
        },
        {
            title: '用户属性',
            name: 'userType',
            tableItem: {},
            dict: [
                { code: 0, codeName: "培训平台用户" },
                { code: 5, codeName: "服务商用户" },
                { code: 4, codeName: "经销商用户" },
                { code: 3, codeName: "OEM部门用户" }
              ]
        },
        {
            title: "账号状态",
            name: "state",
            dataIndex: "state",
            tableItem: {},
            dict: [
              { code: 1, codeName: "激活" },
              { code: 0, codeName: "禁用" }
            ],
            formItem: {
              type: "select"
            }
          },

        {
            title: '操作',
            tableItem: {
                width: 50,
                render: (text, record) => (
                    <WizDataTable.Oper>
                        <WizButton  onClick={e => self._onManagement(record)}>
                        查看任职信息
                        </WizButton>
                    </WizDataTable.Oper>
                )
            }
        }
    ]
}
